import { useEffect } from "react";
import { onLCP, onCLS, onINP, onFCP, onTTFB, type Metric } from "web-vitals";
import { recordWebVital } from "@/lib/rum.functions";
import { initFontMonitoring } from "@/lib/font-monitoring";

// Reports Core Web Vitals (LCP/CLS/INP + FCP/TTFB) to the server for RUM dashboards.
// Reports are batched per metric and only fire once per page lifecycle.
export function WebVitalsReporter() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem("wv_disabled")) return;

    const send = (metric: Metric) => {
      try {
        void recordWebVital({
          data: {
            name: metric.name as "LCP" | "CLS" | "INP" | "FCP" | "TTFB",
            value: Math.round(metric.value * 1000) / 1000,
            rating: metric.rating,
            id: metric.id,
            path: window.location.pathname,
            navigationType: metric.navigationType,
            ua: navigator.userAgent.slice(0, 400),
          },
        });
      } catch {
        // swallow — RUM must never break the page
      }
    };

    onLCP(send);
    onCLS(send);
    onINP(send);
    onFCP(send);
    onTTFB(send);
    initFontMonitoring();
  }, []);

  return null;
}
